import React, { useContext } from 'react'
import { AllStarContext } from '../../../../Context'
import { SelectedPlayersRow } from './SelectedPlayerRow'
import { SelectedList, SelectedTeamCon } from '../../styles'
import { Img } from '../../../../Components/Image/Img'
import { ALL_STAR_TEAM_RULES, AllStarTeamTab } from '../../../../Constant'

type SelectedPlayersListParams = {
  tabs: AllStarTeamTab[]
}

export const SelectedPlayers: React.FC<
  React.PropsWithChildren<SelectedPlayersListParams>
> = ({ tabs }) => {
  const { playerType } = useContext(AllStarContext)!

  const showSelectedTeam = (tab: string) => {
    if (tab === 'Eastern Conference' && playerType === 'east') return true
    if (tab === 'Western Conference' && playerType === 'west') return true
    return false
  }

  return (
    <>
      {tabs.map((t) => (
        <React.Fragment key={t.id}>
          {showSelectedTeam(t.name) === true && (
            <SelectedTeamCon>
              {t.img ? (
                <Img className="teamImg" src={t.img} alt="Selected team icon" />
              ) : (
                <div className="defaultTeamImg" />
              )}
              <SelectedList>
                {Object.keys(ALL_STAR_TEAM_RULES).map((pos) => (
                  <SelectedPlayersRow key={pos} pos={pos} />
                ))}
              </SelectedList>
            </SelectedTeamCon>
          )}
        </React.Fragment>
      ))}
    </>
  )
}
